<template>
  <div class="content-wrapper">
    <section class="group-info">
      <h3 class="impact-light group-count">Plan: <strong>{{ group.planName }}</strong></h3>
      <h2 class="impact-light group-count">Group: <strong>{{ group.name }}</strong></h2>
    </section>

    <Loader v-if="!projectsLoaded" />
    <h2 v-if="projectsLoaded" class="light project-count">Projects: <strong>{{ projects.length }}</strong></h2>
    <section v-if="projectsLoaded" class="cta-wrapper">
      <ProjectBlock
        v-for="(project, index) in projects"
        v-bind:key="index"
        v-bind:project="project"
        v-bind:role="role"
      />
    </section>

  </div>
</template>

<script>
import Loader from '@/components/Loader.vue'
import ProjectBlock from '@/components/group/ProjectBlock.vue'

import { groupService } from '@/services/group.service'

export default {
  name: 'GroupHome',
  components: {
    Loader,
    ProjectBlock
  },
  data () {
    return {
      role: '',
      showModal: false,
      groupId: 0,
      planId: 0,
      group: Object,
      meter: 'Parent',
      projects: Array,
      projectsLoaded: false
    }
  },
  created: function () {
    this.groupId = this.$route.params.groupId

    this.fetchGroup()
    this.fetchProjects()
  },
  methods: {
    fetchGroup: function () {
      // grab the group
      groupService.getGroup(this.groupId).then(group => {
        this.role = group.role
        this.group = group
        if(group.description){
            this.group.description = decodeURIComponent(atob(group.description))
        }
        this.planId = group.planId
        if(group.meterActive) {
          this.meter = 'Own'
        }
      }).catch((err) => {
        console.error('Something went wrong: ', err)
      })
    },
    fetchProjects: function () {
      // grab the group
      groupService.getProjects(this.groupId).then(projects => {
        let archivedProjects = []
        for(let project of projects){
          if(!project.enabled){
            if(project.description){
                project.description = decodeURIComponent(atob(project.description))
            }
            archivedProjects.push(project)
          }
        }
        this.projects = archivedProjects
        this.projectsLoaded = true
      }).catch((err) => {
        console.error('Something went wrong: ', err)
      })
    }
  }
}
</script>

<style lang="scss">
.content-wrapper {
  .welcome {
    margin-bottom: 60px;
  }
}

section.group-info {
  margin-bottom: 85px;
}
</style>
